import { Component, OnInit, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Questions, StudyState, AreaFocus } from '../../models';
import { ServiceInterface } from 'services/service.interface';
import { Location } from '@angular/common';
import { stateConstant } from '../../../constants';
import { ILevel } from 'app/interfaces';


@Component({
  selector: '',
  templateUrl: 'pworkflow.component.html'
})

export class PworkflowComponent implements OnInit, OnChanges {
  index: number;
  model: Questions = new Questions();
  collegeDetails: any;
  states: any[] = stateConstant;
  campaignName = "";
  levels: ILevel[];
  trackWidgetOrigin: string;
  public year:number;
  scholarshipData: any;

  constructor(private router: Router, private _services: ServiceInterface, private _location: Location, private _route: ActivatedRoute) { }

  async ngOnInit() {
    var date = new Date();
    this.year = date.getFullYear();
    this.levels = await this._services.getList('/levels');
    // console.log("HH:",this.index);
    let currentUrl = window.location.href;
    let splitUrl = currentUrl.split("/");
    let checkUrl = splitUrl[3].split("?");
    //console.log("GG:",checkUrl);
    if(checkUrl[0] == "calcmatch"){
      let urlData = currentUrl && currentUrl.split("&");
      let calc = urlData[0] && urlData[0].split("=");
      if(calc.length == 1 ){
        this.index=1;
        this._location.go("/");
        return false;
      }
      this.model.calmatchSrc = calc[1];
      let college = urlData[1] && urlData[1].split("=");
      let collegeId = college[1];
      this.model.passedIn_college_id = collegeId;
      let student = urlData[2] && urlData[2].split("=");
      if (student) {
        let studentUuid = student[1];
        let searchinfo = "";
        searchinfo = await this._services.get('/search/searchinfo/' + studentUuid);
        if (searchinfo == null) {
          this.model.searchdata = "insert";
          searchinfo = await this._services.get('/student/' + studentUuid);
          //console.log("Data:",searchinfo);
          // Set education Data

          this.model.first_name = searchinfo["firstName"];
          this.model.last_name = searchinfo["lastName"];
          // Set personal Data
          /*if(searchinfo["levelId"] == 0){
            this.model.education_goal = "";
          }else{*/
          this.model.education_goal = searchinfo["levelId"];
          //}

          if (searchinfo["bucketId"] == 0) {
            this.model.bucket_id = "";
          } else {
            this.model.bucket_id = searchinfo["bucketId"];
          }
          if (searchinfo["state"].toLowerCase() && searchinfo["state"].toLowerCase() != "online") {
            this.model.study_state = new Array<StudyState>();
            let sitem = new StudyState();
            var thisState = this.states.find(x => x.value.toLowerCase() == searchinfo["state"].toLowerCase());
            sitem.name = thisState.name;
            sitem.value = searchinfo["state"];
            this.model.study_state.push(sitem);
          }
          // Set Military Data
          this.model.military_branch = searchinfo["militaryBranch"];
          this.model.military_status = searchinfo["militaryStatus"];
        } else {
          let studentinfo = await this._services.get('/student/' + studentUuid);
          this.model.searchdata = "update";
          this.model.first_name = studentinfo["firstName"];
          this.model.last_name = studentinfo["lastName"];
          // Set education Data
          if (searchinfo[0]["bucket_id"] == 0) {
            this.model.bucket_id = "";
          } else {
            this.model.bucket_id = searchinfo[0]["bucket_id"];
          }
          //this.model.area_focus= new Array<AreaFocus>();
          this.model.education_goal = searchinfo[0]["education_goal"];
          this.model.online = searchinfo[0]["study_type"];
          /*if(searchinfo[0]["area_focus"] != "" && searchinfo[0]["area_focus"] != null){
            this.model.area_focus_ids = searchinfo[0]["area_focus"];
            let majorData = await this._services.getList('/search/majorlist/'+searchinfo[0]["area_focus"]);
            for (var index = 0; index < majorData.length; index++) {
              csitem = new AreaFocus();
              csitem.name = majorData[index].title;
              csitem.id = majorData[index].id;
              this.model.area_focus.push(csitem);
            }
          }*/

          // Set personal Data
          this.model.study_state = new Array<StudyState>();
          this.model.military_support = searchinfo[0]["military_support"];
          let statelist = searchinfo[0]["study_state"].split(",");
          for (var index = 0; index < statelist.length; index++) {
            let sitem = new StudyState();
            var thisState = this.states.find(x => x.value.toLowerCase() == statelist[index].toLowerCase());
            sitem.name = thisState.name;
            sitem.value = statelist[index];
            this.model.study_state.push(sitem);
          }
          // Set Military Data
          this.model.military_branch = studentinfo["militaryBranch"];;
          this.model.military_status = studentinfo["militaryStatus"];
        }
        this.model.uuid = studentUuid;
        this.index = 1;
        localStorage.setItem("NewUserRegister", 'false');
      }
      if (Number(collegeId) && !student) {
        this._location.go("/calcmatch");
        this.collegeDetails = await this._services.getList("/college/" + collegeId);
        this.index = 1;
      }
    }else if(checkUrl[0] == "match-schools"){
      this._location.go("/");
      const { sid } = this._route.snapshot.queryParams;
      if(sid){
        const checkResult = await this._services.get("/veterans/exist/"+sid);
        if(checkResult == "success"){
          await this.loginAction(sid);
        }
      }
      this.index=1;
    }else if(checkUrl[0] != ""){
      this.campaignName = checkUrl[0];
      let redirectUrl ="?q="+checkUrl[0];
      this._location.go("/"+redirectUrl);
    }else{
      this.index = 1;
      this.checkUrlParam();
    }
    
      if(checkUrl[1] && (checkUrl[1].startsWith("q=app-wgt") || checkUrl[1].startsWith("q=cr-wgt") || checkUrl[1].startsWith("q=mbi-wgt") || checkUrl[1].startsWith("q=mmb-wgt") || checkUrl[1].startsWith("q=amforce-widget"))) {
        let splitData = checkUrl[1] && checkUrl[1].split('&');
        let trackUrl = splitData[0];
        let bucket = splitData[1];
        let state = splitData[2];
        let splitBucket = bucket && bucket.split('=')
        let splitState = state && state.split('=')
        if(bucket && splitBucket[0] == 'goal') {
          this.levels.filter(data => {
            let a = this.model.education_goal;
            if(data.levelId == parseInt(splitBucket[1])) {
              this.model.education_goal = splitBucket[1];
            }
          })
        }
        if(state && splitState[0] == 'state' && splitState[1]) {
          let stateData = [];
          stateData = splitState[1] && splitState[1].split(',');
          this.states.filter(data => {
            stateData.filter(stateData => {
              if(data.value == stateData) {
                let stateItem = new StudyState();
                if (this.model.study_state.findIndex(x => x.value.toLowerCase() == data.value.toLowerCase()) < 0) {
                  stateItem.name = data.name;
                  stateItem.value = data.value;
                  this.model.study_state.push(stateItem);
                }
                  this.model.study_state_values = this.model.study_state.map(a => a.value).join(',');
              }
            })
          })
        }
        
        if(this.levels.filter(data => { return data.levelId == parseInt(this.model.education_goal)}).length > 0 && this.model.study_state.length > 0) {
          this.index = 2;
        } else {
          this.index = 1;
        }
        window.history.replaceState({}, document.title, "/?"+trackUrl);
      }else if(checkUrl[0] == "scholarships"){
        let userinfo = checkUrl[1] && checkUrl[1].split("=");
        if(userinfo){
          this.scholarshipData = await this._services.get("/scholarship/userinfo/" + userinfo[1]);
          if(this.scholarshipData == "nodata"){
            this.index=1;
            this._location.go("/");
          }else{
            this._location.go("/scholarships");
            this.model.first_name = this.scholarshipData[0].first_name;
            this.model.last_name = this.scholarshipData[0].last_name;
            this.model.uuid = userinfo[1];
            this.model.secondary_bucket_ids = this.scholarshipData[0].area_of_focus;
            this.model.study_state_values = this.scholarshipData[0].study_states;
            if(this.scholarshipData[0].study_states.indexOf(",") > -1){
              let stateList = this.scholarshipData[0].study_states.split(",");
              for(let j=0;j<stateList.length;j++){
                let index = this.states.findIndex(x => x.value == stateList[j]);
                this.model.study_state.push({'name':this.states[index].name,'value':this.states[index].value});
              }
            }else{
              let index = this.states.findIndex(x => x.value == this.scholarshipData[0].study_states);
              this.model.study_state.push({'name':this.states[index].name,'value':this.states[index].value});
            }
            //this.model.study_state = [{'name':'Alabama','value':'AL'}];
            if(this.scholarshipData[0].degree_level == "academic_level_undergraduate"){
              this.model.education_goal = "5";
            }else if(this.scholarshipData[0].degree_level == "academic_level_post_graduate"){
              this.model.education_goal = "7,17";
            }else if(this.scholarshipData[0].degree_level == "academic_level_certificate"){
              this.model.education_goal = "18";
            }else if(this.scholarshipData[0].degree_level == "academic_level_trade_vocational"){
              this.model.education_goal = "3,18";
            }else{
              this.model.education_goal = "0";
            }
            this.model.military_branch = '0';
            this.model.military_status = '0';
            this.model.checkCollegeInfo ="";
            this.model.primary_source = 'scholarshipfinder';
            this.model.bucket_id = this.scholarshipData[0].area_of_study;
            this.index=6;
          }
        }else{
          this.index=1;
          this._location.go("/");
        }
      }else if(checkUrl[0] == "activity"){
        let splitData = checkUrl[1] && checkUrl[1].split('&');
        let sourceUrl = splitData[0];
        let mediumUrl = splitData[1];
        let splitSource = sourceUrl && sourceUrl.split('=');
        let splitMedium = mediumUrl && mediumUrl.split('=');
        if(splitSource[1] && splitMedium[1]){
          let trackData = {
            source: splitSource[1],
            medium: splitMedium[1]
          }
          await this._services.post('/program/activity/tracking', trackData);
          this.index=1;
        }
      }else{
        this.index = 1;
        this.checkUrlParam();
      }
  }

  checkUrlParam(){
    let currentUrl = window.location.href;
    let checkUrl = currentUrl.split("?");
    if(checkUrl[1] && checkUrl[1] != ""){
      let campaignUrl = checkUrl[1].split("=");
      this.campaignName = campaignUrl[1];
    }
  }
  ngOnChanges() {
    
  }

  async loginAction(uuid){
    let searchinfo = "";
    let csitem = new AreaFocus();
    searchinfo = await this._services.get('/search/searchinfo/'+uuid);
    if(searchinfo == null){
      this.model.searchdata = "insert";
      searchinfo = await this._services.get('/student/'+uuid);
      //console.log("Data:",searchinfo);
      // Set education Data
      csitem = new AreaFocus();
      
      this.model.first_name = searchinfo["firstName"];
      this.model.last_name = searchinfo["lastName"];
      // Set personal Data
      /*if(searchinfo["levelId"] == 0){
        this.model.education_goal = "";
      }else{*/
        this.model.education_goal = searchinfo["levelId"];
      //}
      
      if(searchinfo["bucketId"] == 0 || !searchinfo["bucketId"]){
        this.model.bucket_id = "";
      }else{
        this.model.bucket_id = searchinfo["bucketId"];
        let primaryBucket = await this._services.get('/bucketlist');
        if(searchinfo["bucketId"].indexOf(",") > -1){
          let primaryBucketData = searchinfo["bucketId"].split(",");
          for(let j=0;j< primaryBucketData.length;j++){
            let index = primaryBucket.findIndex(x => x.bucketId == primaryBucketData[j]);
            this.model.primary_bucket.push({"id":primaryBucket[index].bucketId,"name":primaryBucket[index].bucketTitle});
          }
        }else{
          let index = primaryBucket.findIndex(x => x.bucketId == searchinfo["bucketId"]);
          this.model.primary_bucket.push({"id":primaryBucket[index].bucketId,"name":primaryBucket[index].bucketTitle});
        }
      }

      if(searchinfo["secBucketId"] && searchinfo["secBucketId"] != ""){
        let secBuck = await this._services.get('/secondarybucketlist/'+this.model.bucket_id);
        if(searchinfo["secBucketId"].indexOf(",") > -1){
          let secData = searchinfo["secBucketId"].split(",");
          for(let j=0;j<secData.length;j++){
            let index = secBuck.findIndex(x => x.secBucketId == secData[j]);
            this.model.secondary_bucket.push({"id":secBuck[index].secBucketId,"name":secBuck[index].secBucketTitle});
          }
        }else{
          let index = secBuck.findIndex(x => x.secBucketId == searchinfo["secBucketId"]);
          this.model.secondary_bucket.push({"id":secBuck[index].secBucketId,"name":secBuck[index].secBucketTitle});
        }
      }
      //if(searchinfo["state"].toLowerCase() && searchinfo["state"].toLowerCase() != "online"){
      if(searchinfo["state"]){
        this.model.study_state= new Array<StudyState>();
        let sitem = new StudyState();
        var thisState = this.states.find(x => x.value.toLowerCase() == searchinfo["state"].toLowerCase());
        sitem.name = thisState.name;
        sitem.value = searchinfo["state"];
        this.model.study_state.push(sitem);
      }
      // Set Military Data
      this.model.military_branch = searchinfo["militaryBranch"];
      if(searchinfo["militaryStatus"] == "Retiree"){
        this.model.military_status = "Retired";
      }else{
        this.model.military_status = searchinfo["militaryStatus"];
      }
    }else{
      let studentinfo = await this._services.get('/student/'+uuid);
      this.model.searchdata = "update";
      this.model.first_name = studentinfo["firstName"];
      this.model.last_name = studentinfo["lastName"];
      // Set education Data
      if(searchinfo[0]["bucket_id"] == 0){
        this.model.bucket_id = "";
      }else{
        this.model.bucket_id = searchinfo[0]["bucket_id"];
        let primaryBucket = await this._services.get('/bucketlist');
        if(searchinfo[0]["bucket_id"].indexOf(",") > -1){
          let primaryBucketData = searchinfo[0]["bucket_id"].split(",");
          for(let j=0;j< primaryBucketData.length;j++){
            let index = primaryBucket.findIndex(x => x.bucketId == primaryBucketData[j]);
            this.model.primary_bucket.push({"id":primaryBucket[index].bucketId,"name":primaryBucket[index].bucketTitle});
          }
        }else{
          let index = primaryBucket.findIndex(x => x.bucketId == searchinfo[0]["bucket_id"]);
          this.model.primary_bucket.push({"id":primaryBucket[index].bucketId,"name":primaryBucket[index].bucketTitle});
        }
      }
      //this.model.area_focus= new Array<AreaFocus>();
      this.model.education_goal = searchinfo[0]["education_goal"];
      this.model.online = searchinfo[0]["study_type"];
      
      csitem = new AreaFocus();
      if(searchinfo[0]["secondary_bucket_id"] != ""){
        let secBuck = await this._services.get('/secondarybucketlist/'+this.model.bucket_id);
        if(searchinfo[0]["secondary_bucket_id"].indexOf(",") > -1){
          let secData = searchinfo[0]["secondary_bucket_id"].split(",");
          for(let j=0;j<secData.length;j++){
            let index = secBuck.findIndex(x => x.secBucketId == secData[j]);
            this.model.secondary_bucket.push({"id":secBuck[index].secBucketId,"name":secBuck[index].secBucketTitle});
          }
        }else{
          let index = secBuck.findIndex(x => x.secBucketId == searchinfo[0]["secondary_bucket_id"]);
          this.model.secondary_bucket.push({"id":secBuck[index].secBucketId,"name":secBuck[index].secBucketTitle});
        }
      }
      
      // Set personal Data
      this.model.study_state= new Array<StudyState>();
      this.model.military_support = searchinfo[0]["military_support"];
      let statelist = searchinfo[0]["study_state"].split(",");
      for (var index = 0; index < statelist.length; index++) {
        let sitem = new StudyState();
        var thisState = this.states.find(x => x.value.toLowerCase() == statelist[index].toLowerCase());
        sitem.name = thisState.name;
        sitem.value = statelist[index];
        this.model.study_state.push(sitem);
      }
      // Set Military Data
      this.model.military_branch = studentinfo["militaryBranch"];
      if(studentinfo["militaryStatus"] == "Retiree"){
        this.model.military_status = "Retired";
      }else{
        this.model.military_status = studentinfo["militaryStatus"];
      }
    }
    this.model.uuid =  uuid;
    this.index=1;
    localStorage.setItem("NewUserRegister",'false');
  }

}


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/pworkflow.component.ts